function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "Icon"
}, /*#__PURE__*/React.createElement("rect", {
  id: "Base",
  width: 48,
  height: 48,
  rx: 24,
  fill: "#EBB447"
}), /*#__PURE__*/React.createElement("path", {
  id: "ic-warning",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M24 14C29.5228 14 34 18.4772 34 24C34 29.5228 29.5228 34 24 34C18.4772 34 14 29.5228 14 24C14 18.4772 18.4772 14 24 14ZM24 27C23.4477 27 23 27.4477 23 28C23 28.5523 23.4477 29 24 29C24.5523 29 25 28.5523 25 28C25 27.4477 24.5523 27 24 27ZM24 19C23.4872 19 23.0645 19.386 23.0067 19.8834L23 20V25C23 25.5523 23.4477 26 24 26C24.5128 26 24.9355 25.614 24.9933 25.1166L25 25V20C25 19.4477 24.5523 19 24 19Z",
  fill: "white"
}));

function SvgWarningSircleExclamationYellow(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWarningSircleExclamationYellow);
export default __webpack_public_path__ + "static/media/warning_sircle_exclamation_yellow.87f429ac.svg";
export { ForwardRef as ReactComponent };